import en from './l-en'
import de from './l-de'

/**
 * Internationalization service (i18n), handles the passing of language packages
 * Used idea from: https://www.webtips.dev/making-your-react-app-multilingual-with-vanilla-javascript
*/

const languages = {
    en,
    de
};

let defaultLanguage = window.navigator.language === 'en' ? 'en' : 'de';

window.i18nData = languages[defaultLanguage];

window.i18n = (key) => window.i18nData[key];

window.changeLanguage = (lang) => {
    window.i18nData = languages[lang];
}